import React from 'react';
import { withRouter } from 'react-router-dom';

/**
 * Horizontal status strip shown on Summary and Venues.
 * Each tile is clickable — clicking navigates to the Venues list filtered
 * by that status (?status=…). Re-clicking the active tile clears the filter.
 */

const PIPELINE = [
	{ key: 'Draft', label: 'Draft', color: '#868e96' },
	{ key: 'Sent', label: 'Sent', color: '#009da0' },
	{ key: 'Received', label: 'Received', color: '#1cbcd8' },
	{ key: 'Review', label: 'Under Review', color: '#ff8d60' },
	{ key: 'Shortlist', label: 'Shortlist', color: '#0cc27e' },
	{ key: 'Contracted', label: 'Contracted', color: '#0cc27e' },
	{ key: 'Turndown', label: 'Turndown', color: '#ff586b' },
	{ key: 'Cancel', label: 'Cancelled', color: '#868e96' }
];

const buildCounts = (venues = []) => {
	const counts = {};
	PIPELINE.forEach(p => { counts[p.key] = 0; });
	venues.forEach(v => {
		const status = v.status || 'Draft';
		if (counts[status] === undefined) counts[status] = 0;
		counts[status] += 1;
	});
	return counts;
};

const Tile = ({ def, count, active, onClick, compact }) => (
	<button
		type="button"
		onClick={onClick}
		className={`venuePipelineTile ${active ? 'active' : ''} ${compact ? 'compact' : ''}`}
		style={{
			flex: compact ? '0 0 auto' : '1 1 130px',
			minWidth: compact ? 110 : 130,
			padding: compact ? '8px 12px' : '12px 15px',
			border: `1px solid ${active ? def.color : '#e5e7eb'}`,
			borderRadius: 8,
			background: active ? `${def.color}14` : '#fff',
			cursor: 'pointer',
			textAlign: 'left',
			transition: 'all 0.15s ease',
			display: 'flex',
			flexDirection: 'column',
			gap: 4
		}}
	>
		<div className="flex aic" style={{ gap: 6 }}>
			<span
				style={{
					width: 8,
					height: 8,
					borderRadius: '50%',
					backgroundColor: def.color,
					flexShrink: 0
				}}
			/>
			<span className="small grey" style={{ fontWeight: 500, fontSize: 11, letterSpacing: 0.3, textTransform: 'uppercase' }}>
				{def.label}
			</span>
		</div>
		<div style={{ fontSize: compact ? 18 : 22, fontWeight: 600, color: count > 0 ? '#1a1a1a' : '#b3b3b3', lineHeight: 1 }}>
			{count}
		</div>
	</button>
);

class VenuePipelineStrip extends React.Component {
	navigateTo = (statusKey) => {
		const { history, orgId, requestId, onFilter, activeStatus } = this.props;

		// If controlled (onFilter provided), just call it
		if (onFilter) {
			onFilter(activeStatus === statusKey ? null : statusKey);
			return;
		}

		// Otherwise navigate to venues page with query string
		const next = activeStatus === statusKey ? '' : `?status=${statusKey}`;
		history.push(`/${orgId}/proposal-requests/${requestId}/venues${next}`);
	};

	render() {
		const { venues = [], activeStatus, compact, style } = this.props;
		const counts = buildCounts(venues);
		const total = venues.length;

		return (
			<div
				className="venuePipelineStrip"
				style={{
					display: 'flex',
					flexWrap: compact ? 'nowrap' : 'wrap',
					gap: 10,
					overflowX: compact ? 'auto' : 'visible',
					...style
				}}
			>
				<button
					type="button"
					onClick={() => this.navigateTo(null)}
					className={`venuePipelineTile ${!activeStatus ? 'active' : ''} ${compact ? 'compact' : ''}`}
					style={{
						flex: compact ? '0 0 auto' : '1 1 110px',
						minWidth: compact ? 100 : 110,
						padding: compact ? '8px 12px' : '12px 15px',
						border: `1px solid ${!activeStatus ? '#1a1a1a' : '#e5e7eb'}`,
						borderRadius: 8,
						background: !activeStatus ? '#1a1a1a' : '#fff',
						color: !activeStatus ? '#fff' : 'inherit',
						cursor: 'pointer',
						textAlign: 'left',
						display: 'flex',
						flexDirection: 'column',
						gap: 4
					}}
				>
					<span className="small" style={{ fontWeight: 500, fontSize: 11, letterSpacing: 0.3, textTransform: 'uppercase', color: !activeStatus ? '#fff' : '#888' }}>
						All Venues
					</span>
					<span style={{ fontSize: compact ? 18 : 22, fontWeight: 600, lineHeight: 1 }}>
						{total}
					</span>
				</button>
				{PIPELINE.map(def => (
					<Tile
						key={def.key}
						def={def}
						count={counts[def.key] || 0}
						active={activeStatus === def.key}
						compact={compact}
						onClick={() => this.navigateTo(def.key)}
					/>
				))}
			</div>
		);
	}
}

export { PIPELINE, buildCounts };
export default withRouter(VenuePipelineStrip);
